import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Program } from "../program-maintenance.component";
import { ProgramMaintenanceService } from "src/app/services/program-maintenance.service";
import { NgxSpinnerService } from "ngx-spinner";

@Component({
    selector: 'one-ring-edit-program-dialog-component',
    templateUrl: './edit-program-dialog.component.html',
    styleUrls: ['edit-program-dialog.component.scss']
})
export class EditProgramDialog implements OnInit {
    programForm: FormGroup;

    constructor(
        @Inject(MAT_DIALOG_DATA) public programData: Program, 
        private dialogRef: MatDialogRef<EditProgramDialog>,
        private programMaintenanceService: ProgramMaintenanceService,
        private spinner: NgxSpinnerService
    ) {}

    ngOnInit(): void {
        const formattedStartDate = this.programData.startDate.split('T')[0];
        const formattedEndDate = this.programData.endDate.split('T')[0];

        this.programForm = new FormGroup({
            name: new FormControl({ value: this.programData.name, disabled: true }),
            shortName: new FormControl(this.programData.shortName),
            description: new FormControl(this.programData.description),
            available: new FormControl(this.programData.available),
            startDate: new FormControl(formattedStartDate),
            endDate: new FormControl(formattedEndDate),
            longName: new FormControl(this.programData.longName),
        });
    }

    onSubmit(): void {
        const isAvailable = this.programForm.get('available').value;
        if (isAvailable) {
            this.programForm.patchValue({ available: 1 });
        } else {
            this.programForm.patchValue({ available: 0 });
        }

        this.spinner.show(undefined, { color: '#fff' });
        this.programMaintenanceService.patchProgram(this.programForm.getRawValue())
            .subscribe({
                error: () => {
                    this.spinner.hide();
                },
                complete: () => {
                    this.spinner.hide();
                    this.closeDialog({ isChangeComplete: true });
                }
            });
    }

    closeDialog(object: Object): void {
        this.dialogRef.close(object);
    }
}